import React from 'react';
import SidebarLayout from '@/Components/sidebar/SidebarLayout';
import { AirmailChat } from '@/Pages';

export const UserChats = () => {
    return (
        <SidebarLayout>
            <AirmailChat />
        </SidebarLayout>
    );
};
